(() => {
  const init = () => {
    const track = document.querySelector('.kg-reviews__track');
    if (!track) return;
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const card = track.querySelector('.kg-reviews__card');
      if (!card) return;
      const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
      const max = track.scrollWidth - track.clientWidth;
      let left = track.scrollLeft + (event.key === 'ArrowLeft' ? -distance : distance);
      if (event.key === 'Home') left = 0;
      if (event.key === 'End') left = max;
      track.scrollTo({left: Math.max(0, Math.min(left, max)), behavior: 'instant'});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
